<template>
  <div class="details" v-bind:class="{
        classPopup: showPopup
      }" v-if="showVideo">
    <section
      class="movie-detail-container d-flex flex-column h-75"
      :style="{
        'background-image': 'url(' + seasons.coverart.large + ')',
        'max-width': '100%',
      }"
    >
      <HomeNav />
      <div class="mt-auto flex-shrink-0">
        <div class="container-fluid">
          <div class="row justify-content-end">
            <div class="col-md-12 col-lg-6 col-xl-6">
              <h1  class="mt-5 text-white movie-heading">
                {{ seasonsName }}
              </h1>
              <div class="row text-white py-3"></div>
              <p class="text-white" style="font-size:1vw;">
                {{ seasonsDescription }}
              </p>
              <p class="text-white" style="font-size:1vw;">
                Starring:<span
                  v-for="(Starring, index) in seasonsStarring"
                  :key="index"
                  >{{ Starring }}</span
                >
              </p>
              <p>
                <a
                  @click="playvideo(currentVideo)"
                  v-if="!shouldShowResumeButton(currentVideo)"
                  class="btn btn-lg btn-outline-light ml-2"
                  >Start Watching</a
                >
                <a
                  :href="getresumeHref(currentVideo)"
                  class="btn btn-lg btn-outline-light ml-2"
                  v-if="shouldShowResumeButton(currentVideo)"
                  >Resume</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-auto">
        <div class="container">
          <ul class="nav custom-tabs" id="pills-tab" role="tablist">
            <li class="nav-item mr-5">
              <a
                class="nav-link active"
                data-toggle="pill"
                href="#episodes"
                role="tab"
                aria-selected="true"
                >EPISODES</a
              >
            </li>
            <li class="nav-item mr-5">
              <a
                class="nav-link"
                data-toggle="pill"
                href="#morelink"
                role="tab"
                aria-selected="true"
                >MORE LIKE THIS</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                data-toggle="pill"
                href="#movie-detail"
                role="tab"
                aria-selected="false"
                >DETAILS</a
              >
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="detail-block tab-content" id="pills-tabContent">
      <div class="container tab-pane fade show active" id="episodes">
        <div class="row">
          <div class="col-md-12">
            <select
              class="form-control select-lg border"
              v-model="currentSeason"
            >
              <option
                :value="item.id"
                v-for="(item, index) in seasons.items"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </div>
        <div class="row mt-5">
          <div
            class="col-md-6 col-lg-4 "
            v-for="(card, index) in currentSeasonVideos"
            :key="index"
          >
            <div class="card episode">
              <div class="card-img-top">
                <img class="card-img-top" :src="card.coverart.large" alt="" />
                <div class="episode-number">
                  {{ index + 1 }}
                </div>
                <a @click="playvideo(card)" class="btn-play"
                  ><i class="fa fa-play"></i
                ></a>
              </div>
              <div class="card-body">
                <h5 class="card-title">
                  Episode {{ index + 1 }}
                  <span class="float-right">{{
                    currentSeasonVideosRunningTime(card)
                  }}</span>
                </h5>
                <p class="card-text">
                  {{ currentSeasonVideosDescription(card) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid tab-pane fade" id="morelink">
        <div class="d-flex flex-wrap justify-content-center">
          <div
            class="col-desktop"
            v-for="(card, index) in category_data"
            :key="index"
          >
            <div class="series-block withhover">
              <img class="img-fluid" :src="card.thumbnail.large" alt="" />
              <div class="more-cnt text-center">
                <h5 class="pt-3">{{ categoryDataName }}</h5>
                <p class="py-2">Duration {{ categoryDataRunningTime(card) }}</p>
                <p>PG13</p>
                <p class="py-3">{{ categoryDataDescription(card) }}</p>
                <div class=" d-flex justify-content-between">
                  <a class="">
                    <img src="../assets/img/up.svg" alt="" />
                  </a>
                  <a class="">
                    <img src="../assets/img/dwn.svg" alt="" />
                  </a>

                  <a class="" @click="toggleFavorited(card)">
                    <img
                      src="../assets/img/minis-icon.svg"
                      v-if="my_favourite(card)"
                      alt=""
                      class="plus-icon"
                    />
                    <img class="plus-icon" src="../assets/img/plus.svg" v-else />
                  </a>
                </div>
                <div class="py-3 d-flex justify-content-center">
                  <a @click="gotoDetail(card)" class="d-inline-block">
                    <img src="../assets/img/play.svg" class="play" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container tab-pane fade" id="movie-detail">
        <div class="row detail-link">
          <div class="col-4 col-md-4 col-lg-3">
            <div class="mb-5">
              <h6 class="mb-3">Producer</h6>
              <p>
                {{ seasonsProducer }}
              </p>
            </div>
            <div class="mb-5">
              <h6 class="mb-3">
                Cast
              </h6>
              <p v-for="(cast, index) in seasonsCast" :key="index">
                {{ cast }}
              </p>
            </div>
          </div>
          <div class="col-4 col-md-4 col-lg-3">
            <div class="mb-5">
              <h6 class="mb-3">Writers</h6>
              <p v-for="(Writer, index) in seasonsWriter" :key="index">
                {{ Writer }}
              </p>
            </div>
          </div>
          <div class="col-4 col-md-4 col-lg-3">
            <div class="mb-5">
              <h6 class="mb-3">Genres</h6>
              <p v-for="(Genre, index) in seasonsGenres" :key="index">
                {{ Genre }}
              </p>
            </div>
          </div>
          <div class="col-4 col-md-4 col-lg-3">
            <div class="mb-5">
              <h6 class="mb-3">Maturity Rating</h6>
              <p>{{ seasonsMaturityRating }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Category from "@/components/Category.vue";
import HomeNav from "@/components/HomeNav.vue";

export default {
  name: "DetailSeries",
  components: {
    Category,
    HomeNav,
  },
  watch: {
    "$route.params.vid": {
      handler: function(vid) {
        this.reloadPageData();
      },
      deep: true,
      immediate: true,
    },
    currentSeason: function(val) {
      this.getCurrentSeasonVideos(val);
    },
  },
  computed: {
    FavTitle() {
      if (this.my_favourite(this.currentVideo)) {
        return "Remove from List";
      } else {
        return "Add to List";
      }
    },
    showvideo() {
      if ((currentVideo.name = !"")) {
        return "true";
      } else {
        return "false";
      }
    },
    	showPopup(){
			return this.$store.state.showPopup;
		},
    showplay() {
      if (this.$store.state.globalconfigs.enable_play == "false") {
        return false;
      } else {
        return true;
      }
    },
    seasonsName() {
      if (this.seasons.name) {
        return this.seasons.name;
      }
      return "";
    },
    seasonsDescription() {
      if (this.seasons.description) {
        return this.seasons.description;
      }
      return "";
    },
    seasonsStarring() {
      if (this.seasons.metaData.Starring) {
        return this.seasons.metaData.Starring;
      }
      return "";
    },
    seasonsProducer() {
      if (this.seasons.metaData.Producer) {
        return this.seasons.metaData.Producer;
      }
      return "";
    },
    seasonsCast() {
      if (this.seasons.metaData.Cast) {
        return this.seasons.metaData.Cast.split(",");
      }
      return [];
    },
    seasonsWriter() {
      if (this.seasons.metaData.Writers) {
        return this.seasons.metaData.Writers.split(",");
      }
      return [];
    },
    seasonsGenres() {
      if (this.seasons.metaData.Genres) {
        return this.seasons.metaData.Genres.split(",");
      }
      return [];
    },
    seasonsMaturityRating() {
      if (this.seasons.metaData["Maturity Rating"]) {
        return this.seasons.metaData["Maturity Rating"];
      }
      return "";
    },
    categoryDataName() {
      if (this.category_data.name) {
        return this.category_data.name;
      }
      return "";
    },
  },
  filters: {
    trimdis: function(value) {
      return value.slice(0, 200) + "...";
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
  data() {
    return {
      category_data: {},
      showVideo: false,
      currentVideo: {},
      currentCat: "",
      options: null,
      seasons: null,
      currentSeason: null,
      currentSeasonVideos: null,
      banner: null,
      resume: false
    };
  },
  methods: {
    getresumeHref(current) {
      this.resume = true;
        this.checkSubs(current);
    },
    voteVideo(show, status) {
      this.$store
        .dispatch("voteVideo", {
          id: show.id,
          status: status,
        })
        .then(() => {});
    },
    my_favourite(show) {
      for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
        var item = this.$store.state.user.mylist[i];
        if (item.id == show.id) return true;
      }
      return false;
    },
    toggleFavorited(show) {
      this.$store.commit("refreshMyList", false);
      if (this.my_favourite(show)) {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: false,
            type: show.type,
          })
          .then(() => {
            // this.$store.commit("refreshMyList" ,true)
          });
      } else {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: true,
            type: show.type,
          })
          .then(() => {
            //this.$store.commit("refreshMyList" ,true)
          });
      }
    },
    getActors() {
      return this.currentVideo.metaData.Actor;
    },
    gotoDetail(card) {
      var dynamicRoute = "";
      if (card.type == "vod") {
        dynamicRoute = "/details/" + card.id + "/" + this.$route.params.catid;
      } else if (card.type == "Season") {
        //  dynamicRoute = '/playlistdetails/'+current.id;
      }

      this.$router.push("" + dynamicRoute);
    },

    playvideo(card) {
      this.checkSubs(card);
    },

    checkSubs(current) {
      this.$store
        .dispatch("getVideoPlaybackURLV2", {
          videoId: current.id,
          deviceId: this.duidVal,
        })
        .then((res) => {
          if (current.type == "Series") {
            var currentCat = current.id;
            this.$store.dispatch("getCatalougeById", currentCat).then((res) => {
              var currentSeason = res._embedded.items[0].id;
              this.$store
                .dispatch("getCatalougeById", currentSeason)
                .then((res) => {
                  if(this.resume == true){
                var dynamicRoute = "/viewvideo/" + current.id + "?resume=true";
                this.$router.push("" + dynamicRoute);
              }else
                  var currentSeasonVideoId = res._embedded.items[0].id;
                  var dynamicRoute = "/viewvideo/" + currentSeasonVideoId;
                  this.$router.push("" + dynamicRoute);
                });
            });
          } else {
            var dynamicRoute = "/viewvideo/" + current.id;
            this.$router.push("" + dynamicRoute);
          }
        })
        .catch((err) => {
          if (err.response.data.error.status == "422") {
            // show upgrade screen popup
          }
          if (err.response.data.error.status == "403") {
            this.$store.commit("showPopup", true);
            this.$store.commit("showdefaultFooter", false)
            window.scrollTo(0, 0);
          }
          if (err.response.data.error.status == "404 ") {
            this.$store.commit("showPopup", true);
            //this.$store.commit("setNotification", "Please try again later ");
            window.scrollTo(0, 0);
          }
          this.$store.commit("setLoader", false);
        });
    },
    getCurrentSeasonVideos(id) {
      this.$store.commit("setLoader", true);
      this.$store.dispatch("getCatalougeById", id).then((res) => {
        this.currentSeasonVideos = res._embedded.items;
        this.$store.commit("setLoader", false);
      });
    },
    shouldShowResumeButton(video) {
      return this.$store.getters.isvideoResume(video.id);
    },
    reloadPageData() {
      this.$store.commit("setLoader", true);
      this.currentCat = this.$route.params.catid;
      this.$store
        .dispatch("getCatalougeById", this.$route.params.catid)
        .then((res) => {
          this.seasons = res._embedded;
          this.currentVideo = res._embedded.items[0];
          this.currentSeason = res._embedded.items[0].id;
          this.showVideo = true;
          if (res._embedded.metaData) {
            if (res._embedded.metaData.suggestion) {
              this.$store
                .dispatch("getCatalougeById", res._embedded.metaData.suggestion)
                .then((res) => {
                  this.category_data = res._embedded.items;
                  this.$store.commit("setLoader", false);
                })
                .catch((err) => {
                  this.$store.commit("setLoader", false);
                });
            }
          } else {
            this.$store
              .dispatch("getCatalougeById", this.$route.params.catid)
              .then((res) => {
                this.category_data = res._embedded.items;
                this.$store.commit("setLoader", false);
              })
              .catch((err) => {
                this.$store.commit("setLoader", false);
              });
          }
        });
    },
    categoryDataRunningTime(card) {
      if (card.metaData.running_time) {
        return card.metaData.running_time;
      }
      return "";
    },
    categoryDataDescription(card) {
      if (card.description) {
        return card.description;
      }
      return "";
    },
    currentSeasonVideosRunningTime(card) {
      if (card.metaData.running_time) {
        return card.metaData.running_time;
      }
      return "";
    },
    currentSeasonVideosDescription(card) {
      if (card.description) {
        return card.description;
      }
      return "";
    },
  },
  created() {
    this.$store.commit("showPopup", false);
    if (this.$store.state.user.logedin == false) {
      this.$store.commit("setLoader", false);
      this.$router.push("/login");
      return false;
    }
    this.reloadPageData();

    this.$store.commit("showdefaultFooter", true);
  },
};
</script>

<style scoped>
a,
button {
  cursor: pointer;
}
.mt-auto {
  position: relative;
  z-index: 1;
}
.movie-detail-container {
  min-height: 85vh !important;
}

.movie-detail-container::after {
  min-height: 85vh;
}

.classPopup{
  position:fixed;
}
</style>
